import React, {useEffect, useState} from 'react';
import { Dispatch } from 'redux';
import {useDispatch, useSelector} from 'react-redux';
import './App.scss';
import { Routing } from './components/Routing/Routing';
import { LoginPage } from './pages/Login/LoginPage';
import {ActiveUser} from "./components/ActiveUser/ActiveUser";
import {RootState} from "./redux/reducers";
import { useEnv } from './hooks/useEnv';
import { useAppLoad } from './hooks/useAppLoad';

export let dispatch: Dispatch;
function App() {

  dispatch = useDispatch();
  useEnv();
  useAppLoad();

  const [userSessionActive, setUserSessionActive] = useState<boolean>(false);
  const [darkMode, setDarkMode] = useState<boolean>(true);
  const [theme, setTheme] = useState<string>('dark');


  useSelector((state: RootState) => {
    if (state.activeUser.activeUserIsValid !== userSessionActive) {
      setUserSessionActive(state.activeUser.activeUserIsValid);
    }
    if(state.system.themeDark !== darkMode) {
      setDarkMode(state.system.themeDark);
    }
  });

  useEffect(() => {
    if (darkMode === false) {
      setTheme('light');
      return;
    }

    setTheme('dark');
  }, [darkMode]);
  
  return (
    <div className="App" data-bs-theme={theme}>
      <ActiveUser></ActiveUser>
      {userSessionActive ? <Routing></Routing> : <LoginPage></LoginPage>}
    </div>
  );
}

export default App;
